<template>
  <v-container fluid pa-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid py-0 pb-1>
          <v-row align="center">
            <div>
              <h1 class="headline">Group Templates</h1>
            </div>
            <v-col class="py-0">
              <list-filters
                :filters="filters"
                label="Find Group Template"
                searchButtonId="findTemplateBtn"
                ref-name="templatesListFilters"
                @searchParamsChanged="searchParamsChanged($event)"
                :expansion-panel="false"
              ></list-filters>
            </v-col>
            <div>
              <list-visible-columns-and-filter
                :visible-columns="visibleColumns"
                :selectable-headers="selectableHeaders"
                v-model="search"
                @change="onVisibleColumnsChange"
              ></list-visible-columns-and-filter>
            </div>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    dark
                    color="primary"
                    @click="onCreateNew"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Group Template</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-layout fluid>
      <v-flex xs12>
        <v-data-table
          :headers="filteredHeaders"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="id"
          class="elevation-1"
          fixed-header
          hide-default-footer
          @update:options="onListOptionsUpdate"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
        >
          <template v-slot:item.duration="{ item }">
            {{
              `${item.duration} days/${Number(item.duration) - 1} Nights`
            }}</template
          >
          <template v-slot:item.description="{ item }">{{
            item && item.description && item.description.length > 50
              ? `${item.description.slice(0, 50)}...`
              : item.description
          }}</template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem"
            >
              <template slot="extraButton">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      class="mx-0"
                      @click="onShowTemplateSettings(item)"
                    >
                      <v-icon color="primary" small>mdi-playlist-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Create Itinerary</span>
                </v-tooltip>
              </template>
            </default-list-actions>
          </template>
        </v-data-table>
        <template-settings-dialog
          :show="showTemplateSettings"
          :selected-template="selectedTemplate"
          @createItinerary="onCreateItinerary"
          @onCancel="showTemplateSettings = false"
          create-itinerary
        ></template-settings-dialog>
      </v-flex>
    </v-layout>

    <get-more-results
      :first="first"
      @limitChange="onLimitChange"
      :items="templates"
      :totalItems="totalItems"
      :loading="$apollo.loading"
      :loadMoreEnabled="loadMoreEnabled"
      @loadMore="loadMore('templates')"
    ></get-more-results>
  </v-container>
</template>

<script>
import { ListMixin } from "../../../mixins/ListMixin";
import { ALL_TEMPLATES_SEARCH_QUERY } from "../../../constants/graphql";
import GetMoreResults from "../shared/GetMoreResults";
import DefaultListActions from "../shared/DefaultListActions";
import ListVisibleColumnsAndFilter from "../shared/ListVisibleColumnsAndFilter";
import TemplateSettingsDialog from "./TemplateSettingsDialog";
import ListFilters from "../shared/list-filters/ListFilters";
import templateFilters from "./templates-filters";
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
const CREATE_ITINERARY = gql`
  mutation ($input: ItineraryInput!) {
    createItinerary(itineraryInput: $input) {
      id
      reference
    }
  }
`;
export default {
  name: "GroupTemplateList",

  props: {
    refName: {
      type: String,
      default: () => "g-templates_list",
    },
  },

  mixins: [ListMixin],

  components: {
    GetMoreResults,
    DefaultListActions,
    ListVisibleColumnsAndFilter,
    TemplateSettingsDialog,
    ListFilters,
  },

  data() {
    return {
      templates: {},
      search: "",
      templateFilters: templateFilters,
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "name",
        "destination",
        "department",
        "duration",
        "actions",
      ]),
      headers: [
        {
          text: "Name",

          value: "name",
          name: "name",
        },
        {
          text: "Destination",
          value: "destination.name",
          name: "destination",
        },
        {
          text: "Department",
          value: "department",
          name: "department",
        },
        {
          text: "Duration",
          value: "duration",
          name: "duration",
        },
        {
          text: "Description",
          value: "description",
          name: "description",
        },
        {
          text: "Brand",
          value: "brand",
          name: "brand",
        },
        {
          text: "Internal Status",
          value: "internalStatus",
          name: "internalStatus",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
      showTemplateSettings: false,
      selectedTemplate: {},
    };
  },

  computed: {
    items() {
      return this.templates && this.templates.edges
        ? this.templates.edges.map(removeGQLTypename)
        : [];
    },
    filters() {
      return templateFilters.map((f) => {
        f.props.outlined = this.$store.getters.localSettings("outlinedInputs");
        return f;
      });
    },
  },

  methods: {
    editItem(item) {
      this.$router.push(`/group-template/${item.id}/edit`);
    },
    onCreateNew() {
      this.$router.push("/group-template/new");
    },
    onShowTemplateSettings(item) {
      this.selectedTemplate = { ...item };

      this.showTemplateSettings = true;
    },
    onCreateItinerary(payload) {
      this.$apollo
        .mutate({
          mutation: CREATE_ITINERARY,
          variables: { input: payload },
        })
        .then(({ data }) => {
          this.showTemplateSettings = false;
          this.$store.dispatch("showAppSnackbar", {
            msg: "Itinerary Created.",
          });
          this.$router.push(`/itinerary/${data.createItinerary.id}/details`);
        })
        .catch((err) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: err,
            color: "error",
          });
          console.error(err);
        });
    },
  },

  apollo: {
    templates: {
      query: ALL_TEMPLATES_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          filter: {
            ...this.searchParams,
            templateType_eq: "GROUP",
          },
          sort: this.sort,
        };
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.totalItems = data.templates.totalCount;
        //  this.pagination.totalItems = data.itineraries.totalCount;
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/GroupTemplateList.vue